import React, { Component } from 'react';
import GetInTouch from './getInTouch'; // Your existing form component

const BlogContact =()=> {
    
        const infoStyle = {
            display: "flex",
            alignItems: "center",
            gap: "15px",
            marginBottom: "30px",
            marginRight:"300px"
        };

        const iconCircleStyle = {
            width: "70px",
            height: "70px",
            borderRadius: "50%",
            backgroundColor: "#F1F3F6",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        };

        const iconStyle = {
            fontSize: "28px",
            color: "#25D366", // WhatsApp green
        };

        const phoneIconStyle = {
            ...iconStyle,
            color: "",

        };

        const mailIconStyle = {
            ...iconStyle,
            color: "",
        };

        return (
            <div className="about-area pd-bottom-90" style={{ backgroundColor: "#F4F7FB", padding: "60px 0" }}>
                <div className="container">
                    <div className="row">

                        {/* Left Section */}
                        <div className="col-lg-6">
                            <h2 style={{ fontWeight: "700", fontSize: "36px", color: "#001f3f" }}>
                               Experience Personalized Real Estate Consulting
                            </h2>
                            <p style={{ marginTop: "15px", marginBottom: "40px", color: "#555" }}>
                                At Trinest Sky, we combine market knowledge with tailored service to help you secure the finest properties in Dubai.
                            </p>

                            {/* WhatsApp */}
                            <div style={infoStyle}>
                                <div style={iconCircleStyle}>
                                    <i className="fa fa-whatsapp" style={iconStyle}></i>
                                </div>
                                <div>
                                    <strong>WhatsApp</strong><br />
                                    <a href="https://wa.me/045771575" target="_blank" rel="noopener noreferrer" style={{ color: "#fda94f", textDecoration: "underline" }}>
                                        Click to WhatsApp
                                    </a>
                                </div>
                            </div>

                            {/* Phone */}
                            <a
                                href="tel:+045771575"
                                style={{ textDecoration: "none" }}
                            >
                                <div style={infoStyle}>
                                    <div style={iconCircleStyle}>
                                        <i className="fa fa-phone" style={phoneIconStyle}></i>
                                    </div>
                                    <div>
                                        <strong>Phone</strong><br />
                                        <span>+045771575</span>
                                    </div>
                                </div>
                            </a>
                            {/* Email */}
                            <a href="mailto:ifo@trinestsky.com" style={{ textDecoration: "none" }}>
                                <div style={infoStyle}>
                                    <div style={iconCircleStyle}>
                                        <i className="fa fa-envelope" style={mailIconStyle}></i>
                                    </div>
                                    <div>
                                        <strong>Email</strong><br />
                                        <span>ifo@trinestsky.com</span>
                                    </div>
                                </div>
                            </a>

                        </div>

                        {/* Right Section - Form */}
                        <div className="col-lg-6">
                            <GetInTouch />
                        </div>
                    </div>
                </div>
            </div>
        );
    }


export default BlogContact;
